import Layout from './layout-simple';

export default Layout;